import { commonService } from '.';

const getDcDetails = (body) => {
    return commonService.getWithParam('Dc/details', body);
};

const getDcWithLang = (body) => {
    return commonService.getWithParam('Dc/getDc', body);
};

const downLoadDC = (body) => {
    return commonService.getWithParam('SpireDoc/downLoadDC', body);
};

const getExperiences = (body) => {
    return commonService.getWithParam('Dc/experiences', body);
};

const insertDc = (body, param) => {
    return commonService.postBodyWithParam('Dc/save', body, param);
};

const updateDc = (body, param) => {
    return commonService.putBodyWithParam('Dc/update', body, param);
};

const updateDcStatus = (body) => {
    return commonService.putWithParam('Dc/updateStatus', body);
};

const createNewVersion = (body) => {
    return commonService.postWithParam('Dc/createNewVersionDc', body);
};

const sendMailDC = (body, idLang) => {
    return commonService.post('Dc/sendEmailDC?idLang=' + idLang, body);
}

const infoUserDc = (idUser) => {
    return commonService.getWithParam('Dc/infoUser?idUser=' + idUser);
}

const getDcSkills = (body) => {
    return commonService.getWithParam('Dc/dcSkills', body);
};

const isDCDataOK = (idDc, idLang) => {
    return commonService.getWithParam('Dc/isDCDataOK?idDc=' + idDc + '&idLang=' + idLang, null);
};

const downLoadMiniCV = (idDc, idLang, selectedExperiences) => {
    return commonService.postBlob(
        `SpireDoc/downloadPptx`,
        { idDc, idLang, selectedExperiences }
    );
};

const previewMiniCV = (idDc, idLang, selectedExperiences) => {
    return commonService.postBlob(
        `SpireDoc/previewMiniCV`,
        { idDc, idLang, selectedExperiences }
    );
};

const getBusinessAreaData = (idDc, idLang) => {
    return commonService.getWithParam('Dc/businessArea?idDc=' + idDc + '&idLang=' + idLang, null);
};

export const dcService = {
    getDcDetails,
    getDcWithLang,
    downLoadDC,
    getExperiences,
    insertDc,
    updateDc,
    updateDcStatus,
    createNewVersion,
    sendMailDC,
    infoUserDc,
    getDcSkills,
    isDCDataOK,
    downLoadMiniCV,
    previewMiniCV,
    getBusinessAreaData
};
